<template>
  <div id="index">
    <div class="page1">
    <div>
      <Carrusel ></Carrusel>
    </div>
    <div class="inicio">
      <img alt="inicio" class="img" src="../assets/inicio-min.png" />
      <img alt="inicio" class="img" src="../assets/index/diagram-direction-electronics-1305360-min.jpg" />
      <div>
        <div class="title">
          Calidad y experiencia.
        </div>
        <div class="info">
          Combinamos estrategia, tecnología, ciencia de datos y diseño para resolver los desafíos empresariales más complejos.
          Nuestros equipos especializados lideran el proceso de diseño y desarrollo de productos para empresas de alto crecimiento.
        </div>
      </div>
    </div>

    <div class="nostros">
      <span class="title">¿QUÉ HACEMOS?</span>
      <CardView />
    </div>

    <div class="proyectos" v-if="false">
      <div class="img" :style="{backgroundImage: 'url(' + imageProyecto + ')'}" ></div>

      <span>PROYECTOS EN LOS QUE HEMOS TRABAJADO</span>
      <span>CONOCE ALGUNOS DE LOS PROYECTOS EN LOS QUE HEMOS TENIDO EL PRIVILEGIO DE TRABAJAR.</span>
      <span>
        CONÓCELOS
        <i class="fas fa-arrow-alt-circle-right"></i>
        <div></div>
      </span>
    </div>

    <div class="proyectos2" >
      <div class="img" :style="{backgroundImage: 'url(' + imageFondo + ')'}" ></div>

      <span>Conocer el historial de trabajo de una empresa es <span>IMPORTANTE</span>
      <span>En nuestro afán por ser una empresa responsable ante nuestros clientes,
            SekaiSoft Ofrece un vistazo  a los proyectos en los que hemos trabajado.</span>
      <span>
        CONÓCELOS
        <i class="fas fa-arrow-alt-circle-right"></i>
        <div></div>
      </span>
      </span>
    </div>

    <Contactanos />

  </div>
  </div>
</template>

<script>
  import {mapActions, mapMutations, mapState} from 'vuex'
  import Carrusel from "../components/Carrusel";
  import CardView from "../components/Cards/CardView";
  import Contactanos from "../components/Contactanos";

    export default {
        name: "Index",
      computed: {
        imageProyecto() {
          return require('../assets/index/conocenos.jpg');
        },
        imageRecorte() {
          return require('../assets/index/barra.png');
        },
        imageFondo() {
          return require('../assets/index/StockSnap_XMVLGZZTW3.jpg');
        }
      },
      components: {CardView, Carrusel, Contactanos},
      created() {
          this.select_menu('Home');
        try{
          document.documentElement.scrollTop = 0
        }catch (e) {
          document.scrollingElement.scrollTop = 0;
        }
      },
      methods: {
        ...mapMutations([
          'select_menu',
        ]),
      }
    }
</script>

<style scoped lang="scss">
  @import "../style/base";

  #index {


    & .page1 {
      transition: 2s all ease-in-out;
    }

    & .inicio {
      animation-name: fade;
      animation-duration: 1.5s;
      animation-timing-function: ease-in-out;
      //max-width: 1360px;

      min-height: 400px;
      @include flexColumn;
      @include flexCenter;
      position: relative;
      margin-top: 65px;
      & .img {
        z-index: 1;
        width: 30%;
        min-width: 300px;
        right: 0;
        order: 1;
        margin-bottom: 15px;

        &:first-of-type {
          opacity: 0;
          width: 0;
          position: absolute;
        }
        &:last-of-type {
          opacity: 1;
          width: 30%;
          position: relative;
        }
      }

      & > div {
        order: 2;
        text-align: center;
        & .title {
          z-index: 2;
          @include responsiveFont(50, .6, 300, 800);
          position: relative;
        }
        & .info {
          margin-top: 30px;
          z-index: 3;
          text-align: justify;
          width: 80%;
          margin: 0 auto;
          @include fontFormat(20px, 300, #3c3f40);
          @include responsiveFont(25, .6, 300, 800);
          @include Roboto;
          margin-bottom: 25px;
        }
      }
    }

    & .nostros {
      background: #f5f5f5;
      padding: 35px 20px;

      & .title {
        @include responsiveFont(30);
        position: relative;
        &:AFTER {
          //@include afterLine;
        }
      }
    }

    & .proyectos {
      position: relative;
      width: 100%;
      height: 400px;
      background: #484848;
      & .img {
        background-size: auto 100%;
        background-position: right;
        position: absolute;
        z-index: 1;
        opacity: 1;
        height: 100%;
        width: 100%;
        top: 0;
        left: 0;
        background-repeat: no-repeat;
      }


      & > span {
        @include Roboto;
        @include fontFormat(15px, 400, #FFFFFF);
        position: absolute;
        z-index: 9;
        transform: translateY(-50%);
        width: 350px;
        line-height: 1.2;
        text-align: center;
        right: 35px;

        &:first-of-type{
         // @include fontFormat(15px, 500, $colorSecundary);
          top: 35%;

        }

        &:nth-child(3) {
          top: 42%;

        }

        &:last-of-type {
          //top: 52%;
          width: 120px;
          //right: 150px;
          font-weight: 500;
          transition: 0.5s all ease-in-out;
          line-height: 1.5;


          & div {
            width: 0;
            height: 1px;
            transition: 0.4s all ease-in-out;
            margin: 0 auto;
            background: #FFFFFF;
          }

          &:HOVER {
            color: $colorSecundary;
            cursor: pointer;
            & div {
              width: 30%;
              height: 1px;
              background: greenyellow;
              opacity: 1;
              transition: 0.6s all ease-in-out;
              align-self: center;
            }
          }

        }

      }
    }

    & .proyectos2 {
      @extend .proyectos;
      background: #FFFFFF;
      & .img {
        background-size: cover;
        background-position: center;
      }

      & > span {
        right: 35px;
        top: 45% !important;
        @include flexColumn;
        @include customFont(13, 22);
        width: 400px !important;
        color:  $colorSecundary;
        & > span {

          &:first-of-type{

            color: $colorSecundary;;
          }
          &:nth-child(2){
            color: #FFFFFF;
          }
          &:last-of-type {

          }
        }
      }

    }

    @include responsive_layout('small') {
      & .inicio {
        @include flexRow;

        & .img {
          order: 2;
          margin-bottom: 0px;
          &:first-of-type {
            opacity: 1;
            width: 30%;
            position: relative;
          }
          &:last-of-type {
            opacity: 0;
            width: 0;
            position: absolute;
          }
        }

        & > div {
          order: 1;
          & .title {
            @include responsiveFont(50);
          }
          & .info {
            @include responsiveFont(25);
            width: 70%;
          }
        }
      }

    }

    @include responsive_layout('large') {
      & .inicio {
        & > div {
          & .title {
          }
          & .info {
            width: 50%;
          }
        }
      }
      & .proyectos2 {
        & > span {
          font-size: 22px !important;
          width: 550px !important;
        }
      }
    }

    @include responsive_layout('smallMiddle') {

      & .proyectos {
        & .img {
          //background-position: left;
        }


        & > span {
          //left: 510px;

          &:last-of-type {
            //left: 630px;
          }
        }
      }

    }

    @media only screen and (max-width: 700px) {
      & .proyectos2 {
        & .img {
         background-position: left;
        }
        & > span {
          top: 82% !important;
          right: 0;
        }
      }
    }


    @media only screen and (max-width: 400px) {
      & .inicio {
        & > div {
          & .title {
            @include fontFormat(30px, 500, #000000);
          }
          & .info {
            @include fontFormat(18px, 300, #3c3f40);
          }
        }
      }
    }
  }
</style>
